import loaderComponent from './loader.component';

const loaderModule = angular
  .module('loader', [])
  .component('loader', loaderComponent);

export default loaderModule


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/loader/loader.js
 **/